import { useStaticQuery, graphql } from "gatsby"

import { useApp } from "./useApp"
import { useRoutes } from "./useRoutes"

export const useNavigation = () => {
  const {
    config: {
      settings: { routes },
    },
  } = useApp()
  const { linkResolver } = useRoutes()
  const {
    menus: { account, header, footer },
  } = useStaticQuery(graphql`
    query NAVIGATION {
      menus: sanitySettingMenus {
        account {
          items: _rawItems(resolveReferences: { maxDepth: 2 })
          slug: _rawSlug(resolveReferences: { maxDepth: 2 })
        }
        header {
          items: _rawItems(resolveReferences: { maxDepth: 10 })
          slug: _rawSlug(resolveReferences: { maxDepth: 2 })
        }
        footer {
          items: _rawItems(resolveReferences: { maxDepth: 10 })
          slug: _rawSlug(resolveReferences: { maxDepth: 2 })
        }
      }
    }
  `)

  const mapItems = items =>
    items?.map(item => {
      const type = item?._type?.replace("navigation", "").toLowerCase()
      if (type === `feat`) {
        return {
          type,
          title: linkResolver(item?.link).title,
          titleStyle: item?.titleStyle,
          external_link: item?.external_link,
          mobileTitleAlignment: item?.mobileTitleAlignment,
          subTitle: item?.subTitle,
          mobileSubTitle: item?.mobileSubTitle,
          subtitleOnly: item?.subtitleOnly,
          description: item?.description,
          dynamicimage: item?.dynamicimage,
          dynamiclink: item?.dynamiclink,
          staticimage: item?.staticimage,
          staticlink: item?.staticlink,
          url: linkResolver(item?.link).url || undefined,
          subLinkText: linkResolver(item?.subLink).title,
          subLink: linkResolver(item?.subLink).url || undefined,
          items: item?.items?.length > 0 ? mapItems(item?.items) : [],
          image: item?.image,
          menu_text_color: item?.menu_text_color,
          imageStyle: item?.imageStyle,
          mobileImageSize: item?.mobileImageSize,
          handle: item?.subLink?.document?.shopify?.shopifyHandle,
          link_type: item?.link_type,
        }
      }

      return {
        type,
        image: item?.article?.image,
        title: item?.title,
        link: linkResolver(item?.page || item?.collection || item?.link).url || undefined,
        linkText: item?.link?.title,
        includeSocial: item?.social,
        url: mapUrl(item[type], type),
        items: item?.items?.length > 0 ? mapItems(item?.items) : [],
        itemsDirection: item?.itemsDirection,
        description: item?.description,
        dynamicimage: item?.dynamicimage,
        dynamiclink: item?.dynamiclink,
        dynamiclinkUrl: linkResolver(item?.dynamiclink).url || undefined,
        staticimage: item?.staticimage,
        staticlink: item?.staticlink,
        staticlinkUrl: linkResolver(item?.staticlink).url || undefined,
        menulayout: item?.menulayout,
        menu_text_color: item?.menu_text_color,
        parent_menu_link: item?.parent_menu_link,
        blocktitle: item?.blocktitle,
        links: item?._type === "link" ? item?.link : null,
      }
    })

  const mapUrl = (item, type) =>
    type === "page"
      ? `${routes[item?._type?.toUpperCase().replace("PAGE", "").replace("ACCOUNT", "")]}`
      : type === "product" || type === "collection"
      ? `${routes[type.toUpperCase()] || "/"}/${item?.shopify?.shopifyHandle || ""}`
      : type !== "sub"
      ? `${routes[type.toUpperCase()] || "/"}/${item?.slug?.current || ""}`
      : null

  return {
    header: mapItems(header?.items),
    footer: mapItems(footer?.items),
    account: mapItems(account?.items),
  }
}
